import logoDefaultUser from '../assets/themes/avatar.png';
import logoDefaultCompany from '../assets/themes/company.png';
import imageDefaultProduct from '../assets/themes/product.png';
import imageDefaultService from '../assets/themes/service.png';

export function imageUser(avatar: string | null | undefined): string {
  return (!avatar || avatar.length === 0) ? logoDefaultUser : avatar
}

export function imageCompany(logo: string | null | undefined): string {
  return (!logo || logo.length === 0) ? logoDefaultCompany : logo
}

export function imageService(photo: string | null | undefined): string {
  return (!photo || photo.length === 0) ? imageDefaultService : photo
}

export function imageProduct(photo: string | null | undefined): string {
  return (!photo || photo.length === 0) ? imageDefaultProduct : photo
}
